<template>
    <div class="title">{{ title }}
        <div class="animated infinite rubberBand delay-2s animated color-primary-bghover check-menu"
             @click="showTmm"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        productId: Number
    },
    methods: {
        showTmm() {

        }
    },
}
</script>
